import { BROADCAST_CHANNEL_NAME } from "./constantes";

export const broadCastToken = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
